import * as o from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/X.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "XIcon";
const f = e;
export {
  f as X,
  e as XIcon
};
